import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {Container, Row, Col} from 'reactstrap';
import Loader from '../../../Shared/LocalLoader/LocalLoader';


const LoadingStep = (props) => {

  return (
    <Container className='imei-loading'>
      <Row>
        <Col >
             <Loader/>
        </Col>
      </Row>
    </Container>
  );
};
const mapStateToProps = (state) => {
  return {deviceRepairData: state.iMEIDeviceRepair};
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(LoadingStep);
